import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import {
  EVAL_STATUS_BADGE_CONTENT,
  SHOP_ASSIST
} from "MODULES/RepairOrders/constants";
import { CORE_RETURNED_TO_CUSTOMER } from "MODULES/inventories/constants";
import { TENANT_LOCATION } from "MODULES/shared/components/ShippingSection/shippingTypes";

export const Badge = ({ abbrev, text, icon, label, shouldAbbrev }) => (
  <span className={text}>
    <i className={icon} />
    {shouldAbbrev && abbrev ? abbrev : label}
  </span>
);

Badge.propTypes = {
  abbrev: PropTypes.string,
  shouldAbbrev: PropTypes.bool,
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

const EvaluationStatusBadge = ({ lineItem, shouldAbbrev }) => (
  <Badge
    shouldAbbrev={shouldAbbrev}
    {...EVAL_STATUS_BADGE_CONTENT[lineItem.approval_status]}
  />
);

EvaluationStatusBadge.propTypes = {
  lineItem: PropTypes.shape({}),
  shouldAbbrev: PropTypes.bool
};

export default function StatusBadge({ lineItem = {}, shouldAbbrev = false }) {
  if (lineItem.action_requested === SHOP_ASSIST) {
    return null;
  } else if (lineItem.scrap_report) {
    return (
      <Badge text="text-danger" icon="fa fa-fw fa-trash" label="Scrapped" />
    );
  } else if (
    get(lineItem, "inventory.repair_status") === CORE_RETURNED_TO_CUSTOMER
  ) {
    return (
      <Badge
        text="text-danger"
        icon="fa fa-fw fa-undo"
        label="Core Returned To Customer"
      />
    );
  } else if (
    [TENANT_LOCATION].includes(lineItem.return_to_type) &&
    lineItem.received &&
    (lineItem.exchange_gone_outright || lineItem.internal_outright)
  ) {
    return (
      <Badge
        text="text-danger"
        icon="fa fa-fw fa-undo"
        label="Core Returned From Shop"
      />
    );
  }
  return (
    <EvaluationStatusBadge lineItem={lineItem} shouldAbbrev={shouldAbbrev} />
  );
}

StatusBadge.propTypes = {
  shouldAbbrev: PropTypes.bool,
  lineItem: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/StatusBadges.jsx